import { memo, useCallback } from "react";
import { AccordionDetails } from "@mui/material";

import formatResourceString from "common/format-resource-title";

import AppResourceDto, { FormElemType } from "dto/components/pages/resources/app-resource-dto";

import AppAccordion from "components/app-accordion";
import AppResourceInput from "./app-resource-input";
import AppResourceArrayInput from "./app-resource-array-input";
import AppResourceObjectInput from "./app-resource-object-input";
import AppResourceArrayObjectInput from "./app-resource-array-object-input";

const AppResource = ({ headerKey, headerLabel, info, activeTemplate, templateId }: AppResourceDto) => {
	const headerTitle = headerLabel || formatResourceString(headerKey);

	const ResourceFormElem = useCallback(({ detail }: FormElemType) => {
		const detailType = detail.type;

		switch (detailType) {
			case "array":
				return <AppResourceArrayInput detail={detail} />;

			case "arrayObject":
				return <AppResourceArrayObjectInput detail={detail} />;

			case "object":
				return <AppResourceObjectInput detail={detail} />;

			case null:
			case "string":
				return <AppResourceInput detail={detail} />;

			default:
				return <></>;
		}
	}, []);

	return (
		<AppAccordion className="app-resource" title={headerTitle}>
			<AccordionDetails className="resource__container">
				{info.length > 0 ? (
					<div className="resource__form-wrapper">
						{info.map((item, i) => (
							<ResourceFormElem key={`${item.key}-${i}`} detail={{ ...item, activeTemplate: activeTemplate, page: headerKey, templateId: templateId }} />
						))}
					</div>
				) : (
					<p className="resource__text">No Record Found</p>
				)}
			</AccordionDetails>
		</AppAccordion>
	);
};

export default memo(AppResource);
